module.exports = __webpack_public_path__ + "img/icon-strawberry@2x.673f96cc.png";